import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { IHemoTechLicense } from 'app/models/licenses/hemo-tech/hemo-tech-license';

@Component({
  selector: 'app-hemo-tech-license-export',
  templateUrl: './hemo-tech-license-export.component.html',
  styleUrls: ['./hemo-tech-license-export.component.scss']
})
export class HemoTechLicenseExportComponent {
  @ViewChild('pdf') pdf!: PDFExportComponent;

  public today: Date = new Date(Date.now());

  constructor(@Inject(MAT_DIALOG_DATA) public license: IHemoTechLicense,
              private dialogRef: MatDialogRef<HemoTechLicenseExportComponent>) { }

  exportPDF(): void {
    const fileName = this.license.applicantFirstName + ' ' + this.license.applicantLastName + ' License.pdf';
    this.pdf.saveAs(fileName);
  }

  close(): void {
    this.dialogRef.close();
  }

}
